// extracted by mini-css-extract-plugin
export default {"container":"Kq-z","brandName":"Lq-z","productName":"Mq-z","productNamePdpEnhancements":"Nq-z","breakLongProductName":"Oq-z"};